import { FooterNavigation } from '@models/footer';
import { NavigationEntityAdminApiService } from './navigationEntityAdminApiService';

export class FooterNavigationAdminService extends NavigationEntityAdminApiService<FooterNavigation> {
    public constructor() {
        super('/api/admin/footer-navigation');
    }
}
